import { render, staticRenderFns } from "./ButtonClose.vue?vue&type=template&id=51757e9b&scoped=true&"
import script from "./ButtonClose.vue?vue&type=script&lang=js&"
export * from "./ButtonClose.vue?vue&type=script&lang=js&"
import style0 from "./ButtonClose.vue?vue&type=style&index=0&id=51757e9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51757e9b",
  null
  
)

export default component.exports